import { Checkbox, Form, Input, Select } from "antd";
import { TermsAggreed } from "..";
import { CustomIcon } from 'datastake-daf/dist/components';
import { filterSelectOptions } from "../../../components/DynamicFormNew/helper";

export default function DefaultForm({
  onValuesChange = () => { },
  form,
  initialValues = {},
  displayError = () => { },
  t = (s) => s,
  step = 0,
  registrationData,
  organisation,
  setOrganisation = () => { },
  categories = [],
  categoryUnderstood = false,
  setCategoryUnderstood = () => { },
  showInputs = false,
  subCategories = [],
  economicSectorOptions = [],
  positionInSupplyChain = [],
  countries = [],
  termsAgreed,
  setTermsAgreed = () => { },
}) {
  return (
    <Form
      name="register"
      autoComplete="new-password"
      layout="vertical"
      form={form}
      initialValues={initialValues}
      onValuesChange={onValuesChange}
    >
      <Form.Item
        required
        name="firstName"
        {...displayError('firstName')}
        // hasFeedback
        label={t("Login::Name")}
        rules={[{
          required: true,
          message: t("errors::field is required")
        }]}
        hidden={step !== 0}
      >
        <Input size="large" type="text" placeholder={t("Login::NameP")}></Input>
      </Form.Item>
      <Form.Item
        required
        name="lastName"
        {...displayError('lastName')}
        label={t("Login::Last Name")}
        // hasFeedback
        hidden={step !== 0}
        rules={[{
          required: true,
          message: t("errors::field is required")
        }]}>
        <Input size="large" type="text" placeholder={t("Login::Last NameP")}></Input>
      </Form.Item>
      <Form.Item
        required
        name="email"
        label={t("Email")}
        {...displayError('email')}
        hidden={step !== 0}
        rules={[
          {
            pattern: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
            message: t('errors::email is not valid'),
          },
          {
            required: true,
            message: t("errors::field is required")
          }]}
      >
        <Input
          disabled={!!registrationData}
          size="large"
          type="email"
          placeholder={t("Login::EmailP")}
        />
      </Form.Item>
      <Form.Item
        required
        // hasFeedback
        name="category"
        {...displayError('category')}
        label={t("User Category")}
        rules={[{
          required: step === 1,
          message: t("errors::field is required")
        }]}
        hidden={![1].includes(step)}
      >
        <Select
          className={!!organisation && 'top-select'}
          onChange={(v) => {
            setOrganisation(v);
          }}
          autoComplete="new-password"
          size="large"
          showSearch
          filterOption={filterSelectOptions}
          optionFilterProp="children"
          placeholder={t("User Category")}>
          {categories.map(cat =>
            <Select.Option key={cat.value}>
              {cat.label}
            </Select.Option>
          )}
        </Select>
      </Form.Item>
      {!!organisation && !categoryUnderstood && step === 1 && (
        <div className="category-understood">
          <div className="paragraph">
            <CustomIcon name="Warning" width={60} height={20} />
            <p>
              {t("If your organisation is already active on Datastake, your application will not be reviewed. Instead, please contact the account's main user and request an invitation")}
            </p>
          </div>
          <div className="btn">
            <span
              className="normal-br"
              onClick={() => setCategoryUnderstood(true)}>
              {t('Yes, I understand')}
            </span>
          </div>
        </div>
      )}
      <Form.Item
        required
        hidden={(!showInputs.subCategory || subCategories.length === 0) || step !== 1}
        name="subCategory"
        {...displayError('subCategory')}
        label={t("User sub category")}
        rules={[{
          required: !(!showInputs.subCategory || subCategories.length === 0) && step === 1,
          message: t("errors::field is required")
        }]}
      >
        <Select
          autoComplete="new-password"
          size="large"
          showSearch
          filterOption={filterSelectOptions}
          optionFilterProp="children"
          placeholder={t("User sub category")}>
          {subCategories.map(option =>
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          )}
        </Select>
      </Form.Item>
      <Form.Item
        required
        hidden={!showInputs.economicSector || !!!organisation || step !== 1}
        name="economicSector"
        {...displayError('economicSector')}
        label={t("Economic sector")}
        rules={[{
          required: showInputs.economicSector && !!organisation,
          message: t("errors::field is required")
        }]}>
        <Select
          autoComplete="new-password"
          size="large"
          showSearch
          filterOption={filterSelectOptions}
          optionFilterProp="children"
          placeholder={t("Economic sector")}>
          {economicSectorOptions.map(option =>
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          )}
        </Select>
      </Form.Item>
      <Form.Item
        required
        hidden={!showInputs.positionInSupplyChain || !!!organisation || step !== 1}
        name="positionInTheMineralSupplyChain"
        {...displayError('positionInTheMineralSupplyChain')}
        label={t("positionInTheMineralSupplyChain")}
        rules={[{
          required: showInputs.positionInSupplyChain && !!organisation,
          message: t("errors::field is required")
        }]}>
        <Select
          autoComplete="new-password"
          mode="multiple"
          size="large"
          showSearch
          filterOption={filterSelectOptions}
          optionFilterProp="children"
          placeholder={t("positionInTheMineralSupplyChain")}>
          {positionInSupplyChain.map(option =>
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          )}
        </Select>
      </Form.Item>
      <Form.Item
        required
        hidden={!showInputs.name || !!!organisation || step !== 1}
        {...displayError('name')}
        // hasFeedback
        name="name"
        label={t('Organisation common name')}
        rules={[{
          required: showInputs.name && !!organisation && step === 1,
          message: t("errors::field is required")
        }]}>
        <Input size="large" type="text" placeholder={t('Organisation common name')}></Input>
      </Form.Item>
      <Form.Item
        required
        hidden={!!!organisation || step !== 1}
        // hasFeedback
        name="country"
        {...displayError('country')}
        label={showInputs.name ? t('Registration country') : t("Country")}
        rules={[{
          required: !!organisation && step === 1,
          message: t("errors::field is required")
        }]}>
        <Select
          autoComplete="new-password"
          size="large"
          showSearch
          filterOption={filterSelectOptions}
          optionFilterProp="children"
          placeholder={showInputs.name ? t('Registration country') : t("Country")}>
          {countries.map(country =>
            <Select.Option key={country.value}>
              {country.label}
            </Select.Option>
          )}
        </Select>
      </Form.Item>
      <Form.Item
        required
        name="password"
        {...displayError('password')}
        label={t("Enter password")}
        hidden={step !== 2}
        // hasFeedback
        rules={[{
          required: step === 2,
          message: t("errors::field is required")
        }]}>
        <Input.Password
          size="large"
          placeholder="••••••••" />
      </Form.Item>
      <Form.Item
        required
        name="confirmPassword"
        {...displayError('confirmPassword')}
        label={t("Confirm password")}
        // hasFeedback
        dependencies={['password']}
        hidden={step !== 2}
        rules={[
          {
            required: step === 2,
            message: t("errors::field is required"),
          },
          ({ getFieldValue }) => ({
            validator(rule, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(t('errors::passwordNotMatch'));
            },
          }),
        ]}>
        <Input.Password
          size="large"
          placeholder="••••••••" />
      </Form.Item>
      <Form.Item
        hidden={step !== 2}
        name="mailUpdates" valuePropName="checked" noStyle>
        <Checkbox>{t("Sign up to receive updates")}</Checkbox>
      </Form.Item>
      <Form.Item
        hidden={step !== 2}
        name="agreeTerms" valuePropName="checked" noStyle>
        <TermsAggreed
          termsAgreed={termsAgreed}
          setTermsAgreed={setTermsAgreed}
          t={t}
        />
      </Form.Item>
    </Form>
  )
}
